/** Nomad form field classes for GestionTransferts */
export const inputClass =
  'ui-input-base w-full rounded-[var(--radius-md)] border border-[var(--input)] bg-[var(--card)] px-3 py-2 text-[length:var(--font-size-sm)] text-[var(--foreground)] shadow-[var(--shadow-xs)] placeholder:text-[var(--muted-foreground)] disabled:cursor-not-allowed disabled:opacity-50'

export const labelClass = 'mb-2 block text-[length:var(--font-size-sm)] font-medium text-[var(--foreground)]'

export const textareaClass = `${inputClass} min-h-[88px] resize-y`

export const inputIconWrapClass =
  'flex w-full items-center gap-2 rounded-[var(--radius-md)] border border-[var(--input)] bg-[var(--card)] px-3 py-2 text-[length:var(--font-size-sm)] shadow-[var(--shadow-xs)] focus-within:border-[var(--ring)]'

export const inputIconWrapReadOnlyClass =
  'flex w-full cursor-default items-center gap-2 rounded-[var(--radius-md)] border border-[var(--input)] bg-[var(--muted)] px-3 py-2 text-sm shadow-[var(--shadow-xs)]'

export const inputIconInnerClass =
  'min-w-0 flex-1 border-0 bg-transparent p-0 text-sm text-[var(--foreground)] outline-none placeholder:text-[var(--muted-foreground)] read-only:text-[var(--foreground)]'

export const checkboxClass =
  'h-4 w-4 shrink-0 rounded border-[var(--border)] text-[var(--primary)] focus:ring-[var(--ring)]'
